import { render, staticRenderFns } from "./Withdrawalrecord.vue?vue&type=template&id=001a8439&scoped=true&"
import script from "./Withdrawalrecord.vue?vue&type=script&lang=js&"
export * from "./Withdrawalrecord.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawalrecord.vue?vue&type=style&index=0&id=001a8439&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a8439",
  null
  
)

export default component.exports